import React, { useEffect, useMemo, useState } from 'react'
import { Alert, Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import Select from "react-select";
// import moment from "moment";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import axios from 'axios';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import IconItem from 'components/common/icon/IconItem';

const ReportsNotification = () => {
    const statusMap = {
        D: 'Administered',
        R: 'Refused',
        E: 'Exception',
        M: 'Missed',
        N: 'No action taken yet'
    };
    const [filteredPatient, setFilteredPatient] = useState(null);
    const [filteredDrugRx, setFilteredDrugRx] = useState('');
    const [facilities] = useState(JSON.parse(localStorage.getItem('facilitiesData')));
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [rawMedPassData, setRawMedPassData] = useState([]);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [patientOptions, setPatientOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showImageModal, setShowImageModal] = useState(false);
    const [previewImageUrl, setPreviewImageUrl] = useState(null);

    const columns = [
        {
            accessorKey: 'patient',
            header: 'Patient',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        // {
        //     accessorKey: 'rx',
        //     header: 'Rx',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     }
        // },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'qty',
            header: 'Qty',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'dose',
            header: 'Dose',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'note',
            header: 'Note',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'loa_note',
            header: 'LOA Note',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'status',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'type',
            header: 'Type',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: '',
            header: 'Image',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            },
            cell: ({ row: { original } }) => {
                const imageUrl = original.image;

                return (
                    <>
                        {original.image && <IconItem
                            icon={['fas', 'eye']}
                            tag="button"
                            className="btn btn-sm btn-light"
                            title="View Prescription"
                            onClick={() => {
                                // applyWatermark(imageUrl);
                                setPreviewImageUrl(imageUrl);
                                setShowImageModal(true);
                            }}
                        />}
                    </>
                );
            }
        },
        // {
        //     accessorKey: 'med_image',
        //     header: 'Med Image',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => (
        //         <img
        //             src={original.med_image}
        //             alt="Med Image"
        //             style={{ width: '50px', height: '50px' }}
        //         />
        //     )
        // },
        // {
        //     accessorKey: 'discontinue_image',
        //     header: 'Discontinue Image',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start' },
        //         cellProps: { className: 'text-start' }
        //     },
        //     cell: ({ row: { original } }) => (
        //         <img
        //             src={original.discontinue_image}
        //             alt="Discontinue Image"
        //             style={{ width: '50px', height: '50px' }}
        //         />
        //     )
        // },
        {
            accessorKey: 'administered_by',
            header: 'Administered By',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'administered_Date_Time',
            header: 'Administered Date/Time',
            meta: {
                headerProps: { className: 'text-900 text-start' },
                cellProps: { className: 'text-start' }
            }
        }
    ];

    useEffect(() => {
        const firstFacility = facilities && facilities[0];
        const today = new Date();
        const oneDayBefore = new Date();
        oneDayBefore.setDate(oneDayBefore.getDate() - 1);

        setSelectedFacility(firstFacility || null);
        setStartDate(oneDayBefore);
        setEndDate(new Date());
    }, [facilities]);

    const fetchMedPassData = async () => {
        if (!selectedFacility) return;
        setLoading(true);
        setError("");
        const payload = {
            facility_id: selectedFacility.value,
            from_date: moment(startDate).format("MM/DD/YYYY"),
            to_date: moment(endDate).format("MM/DD/YYYY")
        };
        let tokenStr = localStorage.getItem("accessToken");
        try {

            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/medpass/get-medpass-history/`,
                payload,
                { headers: { Authorization: `Bearer ${tokenStr}` } }
            );
            let results = [];
            let patientSet = new Set();
            let objData = data.medpasses
            objData?.map((item) => {
                // console.log("======>",moment.tz(item.dose_given_datetime, "America/New_York").format("MM/DD/YY hh:mm A"), ">>><<<?>>>>", item.dose_given_datetime);
                results.push({
                    patient_id: item.patient_id,
                    patient: item.patient_lastname + ", " + item.patient_firstname,
                    rx: item.id,
                    drug: item.drug,
                    qty: item.dose_qty,
                    dose: moment(item.dose_date).format("MM/DD/YY") + " " + moment(item.dose_time, "HH:mm:ss").format("hh:mm A"),
                    note: item.note || '-',
                    loa_note: item.loa_hospital_note || '-',
                    status: statusMap[item.dose_status],
                    type: item.med_type == 'C' ? "Cycle" : item.med_type == 'P' ? "PRN" : "Other",
                    administered_Date_Time: item.dose_given_datetime != null ? item.dose_given_datetime : '-',
                    administered_by: item.dose_given_by_username || '-',
                    image: item.med_image,
                    discontinue_image: item.discontinue_med_image_path
                })
                patientSet.add(item.patient_id);
            })

            const patientOptions = [
                { value: 'all', label: "Select All" },
                ...Array.from(patientSet).map((patientId) => {
                    const patient = objData.find(item => item.patient_id === patientId);
                    return {
                        value: patientId,
                        label: `${patient.patient_lastname}, ${patient.patient_firstname}`
                    };
                })
            ];
            setPatientOptions(patientOptions);
            setRawMedPassData(results);
        } catch (err) {
            setError("Error fetching data. Please try again.");
            setTableData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const filteredData = rawMedPassData.filter((entry) => {
            const matchPatient = filteredPatient?.value === 'all' || filteredPatient === null || Number(filteredPatient?.value) == Number(entry?.patient_id);
            const matchDrugRx =
                filteredDrugRx === '' ||
                entry.drug?.toLowerCase().includes(filteredDrugRx.toLowerCase()) ||
                String(entry.rx).includes(filteredDrugRx);

            return matchPatient && matchDrugRx;
        });
        setTableData(filteredData);
    }, [rawMedPassData, filteredPatient, filteredDrugRx]);

    const table = useAdvanceTable({
        data: tableData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <>
            <Card className="p-3 mb-3">
                <Modal show={showImageModal} onHide={() => { setShowImageModal(false); setPreviewImageUrl(null); }} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Prescription Image</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                        {previewImageUrl ? (
                            <img
                                src={previewImageUrl}
                                alt="Prescription"
                                className="img-fluid"
                                style={{ objectFit: 'contain' }}
                            />
                        ) : (
                            <Spinner animation="border" role="status" className="text-center">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowImageModal(false)}>
                            Close
                        </Button>
                        {/* {previewImageUrl && (
                            <a
                                href={previewImageUrl}
                                download={`prescription-${Date.now()}.png`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Button variant="primary">Download</Button>
                            </a>
                        )} */}
                    </Modal.Footer>
                </Modal>
                <Row className="mb-3">
                    <Col md={12}>
                        <Row>
                            <Col md={3}>
                                <Form.Label>Facility</Form.Label>
                                <ThemedSelect
                                    options={facilities}
                                    value={selectedFacility}
                                    getOptionLabel={option => option.key}
                                    getOptionValue={option => option.value}
                                    onChange={setSelectedFacility}
                                    placeholder="Select Facility"
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>Start Date</Form.Label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="MM/dd/yy"
                                    className="form-control"
                                    placeholderText="MM/DD/YY"
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label>End Date</Form.Label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="MM/dd/yy"
                                    className="form-control"
                                    placeholderText="MM/DD/YY"
                                />
                            </Col>
                            <Col md={3} className="d-flex align-items-end">
                                <Button onClick={fetchMedPassData} className="w-100">
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={12} className='mt-3'>
                        <Row>
                            <Col md={4}>
                                <Form.Label>Patient</Form.Label>
                                <ThemedSelect
                                    options={patientOptions}
                                    value={filteredPatient}
                                    onChange={setFilteredPatient}
                                    placeholder="Select Patient"
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label>Drug / Rx</Form.Label>
                                <Form.Control
                                    placeholder="Search by Drug or RX"
                                    value={filteredDrugRx}
                                    onChange={(e) => {
                                        setFilteredDrugRx(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card>
            {loading ? (
                <ShimmerUI />
            ) : error ? (
                <Alert variant="danger">{error}</Alert>
            ) : tableData.length === 0 ? (
                <Alert variant="info">No data available for the selected filters.</Alert>
            ) : (
                <AdvanceTableProvider {...table}>
                    <Card className="p-3">
                        <Card.Body>
                            <Row>
                                <Col xs="12" className="mb-1 mt-1">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-10 mb-0 overflow-hidden'
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <div className="mt-3">
                                <AdvanceTableFooter
                                    rowInfo
                                    navButtons
                                    rowsPerPageSelection
                                />
                            </div>
                        </Card.Footer>
                    </Card>
                </AdvanceTableProvider>
            )}
        </>
    )
}

export default ReportsNotification